import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {Expense} from "../../models/expenses.model";
import {Attachment} from "../../../attachments/models/attachment.model";

export class ExpensesCreateDialogFormComponent implements IController {


  expense: Expense;
  isEditExpense: boolean;

  onUploadImage: Function;
  onChange: Function;

  public currencySymbol: string;
  public attachments: Attachment[];
  public isServiceMandatoryOnExpense: boolean;
  public filtersConfig: any;

  constructor(private splitService, private moment, private deliveriesConstants) {
    this.isServiceMandatoryOnExpense = splitService.getServiceMandatoryOnExpense();
  }

  $onInit() {
    this.filtersConfig = {
      serviceFilters: {
        from: this.moment().startOf('day').valueOf(),
        to: this.moment().endOf('day').valueOf(),
        agentIds: this.expense.agentId ? [this.expense.agentId] : undefined,
        group: this.deliveriesConstants.group.Active
      }
    }

    this.currencySymbol = this.splitService.getCurrencySymbol();
    this.attachments = this.expense.attachments ? angular.copy(this.expense.attachments) : [];
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.expense && !changes.expense.isFirstChange()) {
      this.filtersConfig.serviceFilters.agentIds = this.expense.agentId ? [this.expense.agentId] : undefined

      const currentValue = changes.expense.currentValue,
        previousValue = changes.expense.previousValue;

      if (!_.isEqual(currentValue.attachments, previousValue.attachments)) {
        this.attachments = this.expense.attachments ? angular.copy(this.expense.attachments) : [];
      }
    }
  }

// ******************************
//        Public methods
// ******************************

  onExpenseCategorySelect(id) {
    const expenseCopy = angular.copy(this.expense);
    expenseCopy.categoryId = id;
    this.onChange({expense: expenseCopy})
  }

  onAgentSelect(agent) {
    const expenseCopy = angular.copy(this.expense);
    expenseCopy.agentId = agent.id;
    this.onChange({expense: expenseCopy})
  }

  onServiceSelect(serviceId) {
    const expenseCopy = angular.copy(this.expense);
    expenseCopy.serviceId = serviceId;
    this.onChange({expense: expenseCopy})
  }

  serviceDateChanged(selectedDate) {
    this.filtersConfig.serviceFilters = {
      from: this.moment(selectedDate).startOf('day').valueOf(),
      to: this.moment(selectedDate).endOf('day').valueOf(),
    }
  }

}

angular
  .module('bringoz.admin.expenses')
  .component('expensesCreateDialogForm', {
    require: {
      form: '^form'
    },
    bindings: {
      expense: '<?',
      isEditExpense: '<?',
      onUploadImage: '&',
      onChange: '&'
    },
    template: require('./expenses-create-dialog-form.html').default,
    controller: ExpensesCreateDialogFormComponent
  });

